// Shared media + content constants for the Capital Flow landing
export const IMAGES = {
  heroDroplet:
    "https://static.prod-images.emergentagent.com/jobs/473cd3ec-1f73-47aa-b851-86a696fa9c06/images/7cea03b8d6bbba7ebaecb379a345e2a039e7301d43f54ee6839c6d6f6acb340e.jpeg",
  jug189:
    "https://static.prod-images.emergentagent.com/jobs/473cd3ec-1f73-47aa-b851-86a696fa9c06/images/e717efe09ee195d35fb6f8d3ee976f1f188da00161a2b16504b45ef8f897560f.jpeg",
  jug11:
    "https://static.prod-images.emergentagent.com/jobs/473cd3ec-1f73-47aa-b851-86a696fa9c06/images/431ac3a2af4f0c56df41c33a03885867a5647cc589ba6f60ab5de07d932daa1e.jpeg",
  ottawa:
    "https://images.pexels.com/photos/28488942/pexels-photo-28488942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  business:
    "https://images.pexels.com/photos/7580962/pexels-photo-7580962.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  splash:
    "https://images.pexels.com/photos/144238/water-wave-macro-photography-144238.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
};

export const NAV = [
  { key: "products", href: "#products" },
  { key: "service", href: "#service" },
  { key: "why", href: "#manifesto" },
  { key: "order", href: "#order" },
];

export const CONTACT = {
  phone: "343-543-1714",
  phoneRaw: "3435431714",
  email: "sales@capitalflow.ca",
  site: "capitalflow.ca",
};

// Pricing model (matches capitalflow.ca)
export const PRICING = {
  price189: 10,
  price11: 7,
  deposit: 10,
  minBottles: 4,
};

export const money = (n, lang) =>
  lang === "fr" ? `${n.toFixed(2).replace(".", ",")} $` : `$${n.toFixed(2)}`;

// Service page routes (EN + FR) — single source for canonical URLs, hreflang,
// homepage links and cross-links. Must stay in sync with scripts/seo-content.js.
export const SERVICE_ROUTES = {
  office: { en: "/office-water-delivery-ottawa", fr: "/fr/livraison-eau-bureau-ottawa" },
  home: { en: "/home-water-delivery-ottawa", fr: "/fr/livraison-eau-residentielle-ottawa" },
  distilled: { en: "/distilled-water-delivery-ottawa", fr: "/fr/eau-distillee-ottawa" },
  recurring: { en: "/recurring-water-delivery-ottawa", fr: "/fr/livraison-eau-recurrente-ottawa" },
  construction: { en: "/construction-water-delivery-ottawa", fr: "/fr/livraison-eau-chantier-ottawa" },
};

export const SERVICE_LABELS = {
  en: {
    office: "Office & business water delivery",
    home: "Home water delivery",
    distilled: "Distilled water in Ottawa",
    recurring: "Recurring (standing order) delivery",
    construction: "Construction & contractor water delivery",
  },
  fr: {
    office: "Livraison d'eau pour bureaux",
    home: "Livraison d'eau à domicile",
    distilled: "Eau distillée à Ottawa",
    recurring: "Livraison récurrente (commande permanente)",
    construction: "Livraison d'eau pour chantiers",
  },
};

// Ottawa areas we serve, linked to their area pages.
export const AREA_LINKS = [
  ["kanata", "Kanata"],
  ["orleans", "Orléans"],
  ["nepean", "Nepean"],
  ["barrhaven", "Barrhaven"],
  ["gloucester", "Gloucester"],
];

export const SITE_URL = "https://capitalflow.ca";
